// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'roboto-fontface/css/roboto/roboto-fontface.css';

import App from './App';
import MobileFallback from './components/MobileFallback';
import Desktop from './components/Desktop';

Vue.use(Vuetify, {
  iconfont: 'md',
});

Vue.config.productionTip = false;

const Switch = (resolve) => {
  if (window.matchMedia('(max-width: 767px)').matches) {
    require.ensure(['@/components/MobileFallback'], () => {
      // eslint-disable-next-line global-require
      resolve(require('@/components/MobileFallback'));
    }, 'mobile');
  } else {
    require.ensure(['@/components/Desktop'], () => {
      // eslint-disable-next-line global-require
      resolve(require('@/components/Desktop'));
    }, 'desktop');
  }
};

const VideoAframe = (resolve) => {
  require.ensure(['@/components/VideoAframe'], () => {
    // eslint-disable-next-line global-require
    resolve(require('@/components/VideoAframe'));
  }, 'videoaframe');
};

const VideoPlane = (resolve) => {
  require.ensure(['@/components/VideoPlane'], () => {
    // eslint-disable-next-line global-require
    resolve(require('@/components/VideoPlane'));
  }, 'videoplane');
};

const VideoVimeo = (resolve) => {
  require.ensure(['@/components/VideoVimeo'], () => {
    // eslint-disable-next-line global-require
    resolve(require('@/components/VideoVimeo'));
  }, 'videovimeo');
};

const VideoVimeoMobile = (resolve) => {
  require.ensure(['@/components/VideoVimeoMobile'], () => {
    // eslint-disable-next-line global-require
    resolve(require('@/components/VideoVimeoMobile'));
  }, 'videovimeomobile');
};

const VideoYoutube = (resolve) => {
  require.ensure(['@/components/VideoYoutube'], () => {
    // eslint-disable-next-line global-require
    resolve(require('@/components/VideoYoutube'));
  }, 'videoyoutube');
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',

  routes: [
    { path: '/', component: Switch },
    { path: '/mobile', component: MobileFallback },
    { path: '/desktop', component: Desktop },
    { path: '/video-aframe/:videosrc', name: 'Video Aframe', component: VideoAframe },
    { path: '/video-plane/:videofile', name: 'Video Plane', component: VideoPlane },
    { path: '/video-vimeo/:videoid', name: 'Video Vimeo', component: VideoVimeo },
    { path: '/video-vimeo-mobile/:videoid', name: 'Video Vimeo Mobile', component: VideoVimeoMobile },
    { path: '/video-youtube:videoytid', name: 'Video Youtube', component: VideoYoutube },
  ],
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log(`Service Worker registered! Scope: ${registration.scope}`);
      })
      .catch((err) => {
        console.log(`Service Worker registration failed: ${err}`);
      });
  });
}

window.addEventListener('appinstalled', (evt) => {
  console.log('a2hs installed: ', evt);

  // TODO: force reload whole project to detect if the display-mode is standalone and in
  // that case route all video through VideoAframe component:
  // https://developers.google.com/web/fundamentals/app-install-banners
  // https://github.com/rohan12patil/pwa/blob/master/main.js
});

if (window.matchMedia('(display-mode: standalone)').matches) {
  console.log('display-mode is standalone');
  // TODO: see above
} else {
  console.log('display-mode is normal. Okay!');
}



// WEBPACK FOOTER //
// ./src/main.js